var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var Footer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, numRows = _a.numRows;
    return "\n    grid-row: ".concat(numRows + 2, ";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 35px;\n    background-color: blue;\n    background-color: ").concat(theme.bgContent(), ";\n    padding: 0rem .5rem;\n    box-shadow: 0px -2px 3px 0px ").concat(theme.borderContent(), ";\n");
});
export var TableFooter = function (_a) {
    var numRows = _a.numRows;
    return (React.createElement(Footer, { numRows: numRows },
        React.createElement("div", null, "left"),
        React.createElement("div", null, "center"),
        React.createElement("div", null,
            numRows,
            " Rows")));
};
var templateObject_1;
